import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useCart } from "@/lib/cart";
import { toast } from "sonner";

export default function ShopTheLook() {
  const [looks, setLooks] = useState([]);
  const cart = useCart();
  const { user } = useAuth();

  useEffect(() => { api.get("/lookbook").then(({ data }) => setLooks(data)); }, []);

  const addAll = async (look) => {
    if (!user) return toast("Sign in to add the look");
    for (const p of look.products) {
      try { await cart.add(p.id, { quantity: 1, size: p.sizes?.[0], color: p.colors?.[0] }); } catch {}
    }
    toast.success(`Added ${look.products.length} pieces from ${look.title}`);
  };

  return (
    <main className="sq-container py-12" data-testid="shop-the-look-page">
      <div className="sq-eyebrow text-squire-jeans">Editorial · Shop the Look</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Curated looks, one click away.</h1>

      <div className="mt-12 space-y-16">
        {looks.map((look, i) => (
          <article key={look.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`look-${look.id}`}>
            <div className="aspect-[4/5] overflow-hidden">
              <img src={look.cover_image} alt={look.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div>
              <div className="sq-eyebrow">{look.season || "Curated"}</div>
              <h2 className="font-display text-4xl md:text-5xl mt-2">{look.title}</h2>
              <p className="text-[#4B5563] mt-3 max-w-md">{look.description}</p>
              <div className="grid grid-cols-2 gap-4 mt-6">
                {look.products?.map((p) => (
                  <Link key={p.id} to={`/product/${p.id}`} className="group" data-testid={`look-product-${p.id}`}>
                    <div className="aspect-[3/4] overflow-hidden bg-[#F5F5F5]"><img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform" /></div>
                    <div className="mt-2 flex items-center justify-between"><div className="font-display text-sm">{p.name}</div><div className="text-sm font-semibold">{formatINR(p.price)}</div></div>
                  </Link>
                ))}
                {!look.products?.length && <div className="col-span-2 text-sm text-[#4B5563]">No products linked yet.</div>}
              </div>
              {look.products?.length > 0 && (
                <button data-testid={`look-add-all-${look.id}`} onClick={() => addAll(look)} className="sq-btn-primary mt-8">Shop the Look — Add All</button>
              )}
            </div>
          </article>
        ))}
        {!looks.length && <div className="text-[#4B5563]">No looks yet. Admin can add them via the dashboard.</div>}
      </div>
    </main>
  );
}
